import SidebarLayout from './SidebarLayout';
import { ADMIN_NAV } from './nav';

/** Administration layout (users, organization, audit, ingestion errors). */
export default function AdminLayout() {
  return <SidebarLayout nav={ADMIN_NAV} title="مدیریت سامانه" />;
}
